export const HANDOFF_ENDPOINT = '/c/v2.1/chat/handoff';
